import React from 'react';
import classNames from 'classnames';

import {SCHEDULE_ITEM_TYPES} from 'ducks/tenancy';

import {formatDate} from 'utils/datetime';

import Alert from 'components/Alert';
import Table from 'components/Table';
import Money from 'components/Money';
import Ellipsis from 'components/Ellipsis';
import PaymentStatusTag from 'components/PaymentStatusTag';

import {getSyncedWithXeroIcon} from 'containers/BookingDetail/utils';

const RefundRow = ({refund, handleRowClick, scheduleType}) => {
  const {refundDetails} = refund;

  return (
    <Table.Row
      className={classNames('scheduleRow', {
        highlighted: refund.highlighted
      })}
      onClick={() =>
        handleRowClick(SCHEDULE_ITEM_TYPES.REFUND, refund.id, scheduleType)
      }>
      <Table.Cell>{formatDate(refund.date)}</Table.Cell>
      <Table.Cell />
      <Table.Cell className="activity">
        <div className="colab-centered">
          {refundDetails.hasXeroErrors && <Alert />}
          <Ellipsis>{refund.activity}</Ellipsis>
        </div>
      </Table.Cell>
      <Table.Cell className="details">
        <Ellipsis>{refundDetails.reference}</Ellipsis>
      </Table.Cell>
      <Table.Cell>
        {refundDetails.voided && (
          <PaymentStatusTag status={PaymentStatusTag.VOIDED} />
        )}
      </Table.Cell>
      <Table.Cell>{getSyncedWithXeroIcon(refundDetails.xeroId)}</Table.Cell>
      <Table.Cell />
      <Table.Cell className="payment">
        <Money
          amount={-refund.amount}
          balance
          className={classNames({
            strikeThrough: refundDetails.voided
          })}
        />
      </Table.Cell>
      <Table.Cell className="balance">
        <Money amount={refund.balance} balance />
      </Table.Cell>
    </Table.Row>
  );
};

export default RefundRow;
